/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */

import { FieldError } from '@olist/united';

export const withError =
  (Component) =>
  ({ input, meta, ...rest }) => {
    const hasErrorAndTouched = meta.error && meta.touched;
    const hasSubmitError = !meta.dirtySinceLastSubmit && meta.submitError;

    return (
      <Component
        error={hasErrorAndTouched || hasSubmitError}
        input={input}
        meta={meta}
        {...input}
        {...rest}
      />
    );
  };

export const withFieldError =
  (Component) =>
  ({ input, meta, ...rest }) => {
    const hasErrorAndTouched = meta.error && meta.touched;
    const hasSubmitError = !meta.dirtySinceLastSubmit && meta.submitError;
    const errors = meta.error || meta.submitError;

    return (
      <>
        <Component input={input} meta={meta} {...input} {...rest} />
        {(hasErrorAndTouched || hasSubmitError) && <FieldError messages={errors} />}
      </>
    );
  };

export const withSuccess =
  (Component) =>
  ({ input, meta, ...rest }) =>
    (
      <Component
        input={input}
        meta={meta}
        success={meta.touched && meta.valid}
        {...input}
        {...rest}
      />
    );
